module.exports = __webpack_public_path__ + "img/redPacket.e23c4357.gif";